const indexItems = [
  {
    title: '顶流恋情实锤',
    desc: '最新明星恋情曝光全记录，时间线还原从暧昧到官宣的每一个细节',
    icon: 'ri-heart-pulse-line',
    color: 'primary',
  },
  {
    title: '综艺翻车现场',
    desc: '热门综艺节目翻车名场面合集，艺人社死瞬间一次看够',
    icon: 'ri-emotion-laugh-line',
    color: 'accent',
  },
  {
    title: '影视剧透专区',
    desc: '未播影视剧独家路透与剧情预测，抢先了解下周剧情走向',
    icon: 'ri-film-line',
    color: 'primary',
  },
  {
    title: '红毯造型盘点',
    desc: '各大颁奖礼与时尚盛典红毯造型全解析，谁穿对了谁翻车',
    icon: 'ri-t-shirt-line',
    color: 'accent',
  },
  {
    title: '合约纠纷内幕',
    desc: '艺人合约到期、解约风波与经纪公司矛盾深度挖掘',
    icon: 'ri-file-text-line',
    color: 'primary',
  },
  {
    title: '音乐现场直击',
    desc: '演唱会与音乐节最新现场报道，从歌单到舞台全方位回顾',
    icon: 'ri-music-line',
    color: 'accent',
  },
  {
    title: '私生活大起底',
    desc: '明星私生活细节与未公开照片合集，满足你的好奇心',
    icon: 'ri-camera-line',
    color: 'primary',
  },
  {
    title: '跨界合作吃瓜',
    desc: '艺人跨界商业合作与品牌代言最新动态，谁拿下了大单',
    icon: 'ri-briefcase-line',
    color: 'accent',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="bg-background-50 py-16 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4">
              专题索引
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
              热门专题合集
            </h2>
            <p className="text-foreground-600 text-sm max-w-xl mx-auto">
              按专题分类浏览吃瓜内容，快速定位你最感兴趣的八卦方向
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {indexItems.map((item) => (
              <a
                key={item.title}
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="group flex items-start gap-4 p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-background-100 transition-all duration-200 cursor-pointer"
              >
                <div
                  className={`w-11 h-11 flex-shrink-0 flex items-center justify-center rounded-lg ${
                    item.color === 'primary'
                      ? 'bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-white'
                      : 'bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-white'
                  } transition-colors duration-200`}
                >
                  <i className={`${item.icon} text-lg`}></i>
                </div>
                <div className="min-w-0">
                  <h3 className="font-semibold text-sm text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-foreground-500 text-xs leading-relaxed line-clamp-2">
                    {item.desc}
                  </p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}